import {inElementUi} from './formElementSetup';

export const rawSelectStyling = () => `
    .dropdown-select {
        &__option{
            font-size: var(--text-size-default);
            color: var(--default-text-color);
            &.dropdown-select__option--is-focused {
                background: var(--form-control-dropdown-focus-select);
            }

            &.dropdown-select__option--is-selected {
                background: var(--primary);
                color: var(--white-00);
            }
        }

        &__control,
        &__control--is-focused,
        &__control--menu-is-open,
        &__control:hover {
            // -------------------
            // --- over-writes ---
            // -------------------
            box-shadow: none;
        }
        &__indicator-separator{
            display: none;
        }
        &__clear-indicator  svg{
            width: 17px;
            color: var(--select-clear-indicator);
            cursor: pointer;
            margin-right: 16px;
            &:hover{
                color: var(--select-clear-indicator-hover);
            }
        }
        &__indicator {
            padding-right:2px;
        }
        

        &__placeholder,
        &__input-container,
        &__input {
            height: var(--height-form-control);
            min-height: var(--height-form-control);
            max-height: var(--height-form-control);
        }

        &__control{
            height: 34px;
            min-height: 34px;
            max-height: 34px;
        }

        &__menu-list > div,
        &__control {
            cursor: pointer;
        }

        &__menu-list,
        &__menu {
            background: var(--form-control-background-color);
        }

        &__menu {
            box-shadow: var(--form-control-dropdown-shadow);
            z-index: 9999;
            border-radius: var(--radius-form-control);
            overflow: auto;
        }

        &__control {
            background: none;
            border: none;
        }
        
        &__input-container,
        &__value-container {
            padding: 0;
            margin: 0;
        }

        &__placeholder,
        &__input,
        &__single-value,
        &__input-container  {
           padding: 0 var(--padding-form-control-horz);
           line-height: calc(var(--height-form-control) - 2px);
           ${inElementUi()};
        }

        &__placeholder {
           color: var(--label-text-color);
        }

        &__input,
        &__single-value,
        &__input-container  {
           color: var(--default-text-color);
        }
        &__single-value--is-disabled {
            color: var(--form-control-disabled-text-color)!important;
        }
        &__indicator.dropdown-select__dropdown-indicator svg {
            display: none;
        }
    } 
`;
